import React, { useState, useEffect } from "react";
import {
  Container,
  Header,
  ActionButtons,
  StatusContainer,
  PaginationContainer,
  ButtonPagination,
  StyledModal,
  FormField,
  Label,
  Input,
  TextArea,
} from "./styles";
import { FiExternalLink } from "react-icons/fi";
import * as dateFNS from "date-fns";

import { Table, Button } from "semantic-ui-react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import InputSearch from "../components/InputSearch";
import { RiDeleteBinLine } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { Toggle } from "../components/Toggle";
import {
  local,
  producaov2 as api,
  producaov2,
} from "../../../../services/apis";
import CreateLMSModal from "./CreateLMSModal";
import { smallDateFormat } from "../../../../utils/Utils";

const statusType = {
  1: "Inativo",
  2: "Ativo",
  3: "Free",
};

export const NovoListarEmpresas = () => {
  const [search, setSearch] = useState("");
  const [companies, setCompanies] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [open, setOpen] = useState(false);
  const [dataReturn, setDataReturn] = useState();
  const [selectedLmsID, setSelectedLmsID] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    valid_employees: "",
    logo: "",
    url: "",
    level: 1,
    status: 1,
    pessoa: {
      nome: "",
      email: "",
    },
    trilha: {
      title: "",
      description: "",
      cursos: "2066,5120,5688,5689",
    },
  });

  const getCompanies = async () => {
    await producaov2
      .get(`/admin/incompany/v3?page=${page}&search=${search}`)
      .then((res) => {
        setCompanies(res.data.companies);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getCompanies();
  }, [search, page]);

  const handleUpdateStatus = async (id, status) => {
    const data = {
      status: status ? 2 : 1,
    };

    await api
      .put(`/admin/incompany/v3/${id}/change-status`, data)
      .then((res) => {
        const newCompanies = companies.map((company) => {
          if (company.id === id) {
            company.status = data.status;
          }
          return company;
        });

        setCompanies(newCompanies);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getFimTeste = (dataInicio, dias) => {
    const startDate = new Date(dataInicio);

    startDate.setDate(startDate.getDate() + dias + 1);

    const day = startDate.getDate();
    const month = startDate.getMonth() + 1;
    const year = startDate.getFullYear();

    const formattedDate = `${day < 10 ? "0" : ""}${day}-${
      month < 10 ? "0" : ""
    }${month}-${year}`;

    return formattedDate;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.startsWith("pessoa.")) {
      const field = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        pessoa: { ...prev.pessoa, [field]: value },
      }));
    } else if (name.startsWith("trilha.")) {
      const field = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        trilha: { ...prev.trilha, [field]: value },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.valid_employees ||
      !formData.logo ||
      !formData.url ||
      !formData.level ||
      !formData.status ||
      !formData.pessoa.nome ||
      !formData.pessoa.email ||
      !formData.trilha.title ||
      !formData.trilha.description ||
      !formData.trilha.cursos
    ) {
      swal("Erro", "Todos os campos são obrigatórios!", "error");
      return;
    }

    // Validação do e-mail (formato válido)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.pessoa.email)) {
      swal("Erro", "Por favor, insira um e-mail válido!", "error");
      return;
    }

    // Validação da URL (somente letras minúsculas e hifens)
    const urlRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
    if (!urlRegex.test(formData.url)) {
      swal(
        "Erro",
        "A URL deve estar no formato 'algo-algo' sem caracteres especiais ou espaços!",
        "error"
      );
      return;
    }

    await producaov2
      .post(`/admin/incompany/create-lms-now`, formData)
      .then(async (res) => {
        swal(
          "Cadastro efetuado com sucesso",
          "O email enviado foi vinculado com a senha padrão",
          "success"
        );
        const logs = {
          local: "admin/lms",
          texto: `Criou uma nova empresa: ${formData.name}`,
        };
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
        setDataReturn(res.data);
        return;
      })
      .catch((err) => {
        return;
      });
  };

  const handleEditLms = (lmsID) => {
    setSelectedLmsID(lmsID);
    setShowModal(true);
  };

  const handleCreateLms = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedLmsID(null);
    setShowModal(false);
  };

  const handleDeleteLms = async (id) => {
    await producaov2
      .delete(`/incompany-delete/${id}`)
      .then(async (res) => {
        swal("Exclusão efetuada com sucesso", "", "success");
        const logs = {
          local: "admin/lms",
          texto: `Excluiu uma empresa: ${id}`,
        };
        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });
        return;
      })
      .catch((err) => {
        return;
      });
  };

  return (
    <>
      <div style={{ width: "100%", paddingLeft: "250px" }}>
        <AdminMenu />
        <Container>
          <Header>
            <h1>Lista de Empresas</h1>
            <div>
              <InputSearch
                placeholder="Pesquisar"
                value={search}
                onChange={(e) => {
                  setPage(1);
                  setSearch(e.target.value);
                }}
                noIcon
                minWidth="500px"
              />
              <button className="button-primary" onClick={handleCreateLms}>
                Criar empresa
              </button>
              {/* <button
                className="button-green"
                style={{
                  background: "green",
                }}
                onClick={() => setOpen(true)}
              >
                Criação Rápida
              </button> */}
            </div>

            <PaginationContainer>
              <div>
                {Array.from(Array(totalPages).keys())
                  .map((_, index) => (
                    <ButtonPagination
                      active={page === index + 1}
                      onClick={() => setPage(index + 1)}
                    >
                      {index + 1}
                    </ButtonPagination>
                  ))
                  .slice(
                    page <= 2
                      ? 0
                      : page + 2 >= totalPages
                      ? totalPages - 5
                      : page - 3, // clean code :)
                    page <= 2
                      ? 5
                      : page + 2 >= totalPages
                      ? totalPages
                      : page + 2
                  )}
              </div>
            </PaginationContainer>
          </Header>

          <Table celled>
            <Table.Header>
              <Table.HeaderCell>
                <div>ID</div>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <div>Nome</div>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <div>URL</div>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <div>Validade</div>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <div>Licenças</div>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <div>Status</div>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <div>Ações</div>
              </Table.HeaderCell>
            </Table.Header>

            <Table.Body>
              {companies &&
                companies.length > 0 &&
                companies.map((company) => (
                  <Table.Row key={company.id}>
                    <Table.Cell>
                      <div>{company.id}</div>
                    </Table.Cell>
                    <Table.Cell>
                      <div>{company.name}</div>
                    </Table.Cell>
                    <Table.Cell>
                      <a
                        href={`https://${company.url}.voitto.com.br/para-empresas`}
                        target="_blank"
                        style={{
                          maxWidth: "25rem",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          display: "block",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <FiExternalLink />
                        {`https://${company.url}.voitto.com.br/para-empresas`}
                      </a>
                    </Table.Cell>
                    <Table.Cell>
                      <div>
                        {company?.expires_in
                          ? smallDateFormat(new Date(company.expires_in))
                          : "Sem Prazo"}
                      </div>
                    </Table.Cell>
                    <Table.Cell>
                      <div>
                        {company.usedLicenses}/{company.valid_employees}
                      </div>
                    </Table.Cell>
                    <Table.Cell>
                      <StatusContainer>
                        {statusType[company.status] || "Desconhecido"}
                        <Toggle
                          checked={company.status === 2} // 1: inativo | 2: ativo | 3 : free (Como vai ser o free?)
                          onChange={(currentStatus) =>
                            handleUpdateStatus(company.id, currentStatus)
                          }
                        />
                      </StatusContainer>
                    </Table.Cell>
                    <Table.Cell>
                      <ActionButtons>
                        <button onClick={() => handleEditLms(company.id)}>
                          <FaRegEdit size={16} color="var(--color-primary)" />
                        </button>
                        <button onClick={() => handleDeleteLms(company.id)}>
                          <RiDeleteBinLine size={16} color="#96989A" />
                        </button>
                      </ActionButtons>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </Container>
      </div>
      <StyledModal open={open} onRequestClose={() => setOpen(false)}>
        <div
          style={{
            position: "absolute",
            right: 20,
            top: 10,
            fontSize: "1rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
          onClick={() => {
            setOpen(false);
            setDataReturn(null);
          }}
        >
          X
        </div>
        {dataReturn ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <p>
              <strong>URL LMS: </strong>
              <a href={dataReturn.url_lms}>dataReturn.url</a>
            </p>
            <p>
              <strong>Login: </strong>
              {dataReturn.login}
            </p>
          </div>
        ) : (
          <>
            <h3>Criar novo LMS</h3>
            <form onSubmit={handleSubmit}>
              <FormField>
                <Label htmlFor="name">Empresa</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  placeholder="Nome da Empresa"
                  onChange={handleChange}
                />
              </FormField>

              <FormField>
                <Label htmlFor="valid_employees">Licenças</Label>
                <Input
                  type="number"
                  id="valid_employees"
                  name="valid_employees"
                  placeholder="Número de licenças disponíveis"
                  value={formData.valid_employees}
                  onChange={handleChange}
                />
              </FormField>

              <FormField>
                <Label htmlFor="logo">Logo URL</Label>
                <Input
                  type="text"
                  id="logo"
                  name="logo"
                  value={formData.logo}
                  placeholder="Faça o upload da imagem, pegue o link e cole aqui"
                  onChange={handleChange}
                />
                <a href="/admin/upload/anexos" target="_blank">
                  Fazer upload aqui
                </a>
              </FormField>

              <FormField>
                <Label htmlFor="url">URL</Label>
                <Input
                  type="text"
                  id="url"
                  name="url"
                  placeholder='A url não deve conter acentos ou caracteres especiais. Separe sempre por  "-" = voitto-tech'
                  value={formData.url}
                  onChange={handleChange}
                />
              </FormField>

              {/* <FormField>
            <Label htmlFor="level">Nível</Label>
            <Input
              type="number"
              id="level"
              name="level"
              value={formData.level}
              placeholder="1 = Gestor , 2 = Líder, 3 = Colaborador"
              onChange={handleChange}
            />
          </FormField>

          <FormField>
            <Label htmlFor="status">Status</Label>
            <Input
              type="number"
              id="status"
              name="status"
              placeholder="1 = inativo , 2 = ativo"
              value={formData.status}
              onChange={handleChange}
            />
          </FormField> */}

              <FormField>
                <Label htmlFor="pessoa.nome">Nome da Pessoa</Label>
                <Input
                  type="text"
                  id="pessoa.nome"
                  name="pessoa.nome"
                  placeholder="Nome da pessoa a ser cadastrada"
                  value={formData.pessoa.nome}
                  onChange={handleChange}
                />
              </FormField>

              <FormField>
                <Label htmlFor="pessoa.email">Email da Pessoa</Label>
                <Input
                  type="email"
                  id="pessoa.email"
                  name="pessoa.email"
                  placeholder="Email da pessoa a ser cadastrada"
                  value={formData.pessoa.email}
                  onChange={handleChange}
                />
              </FormField>

              <FormField>
                <Label htmlFor="trilha.title">Título da Trilha</Label>
                <Input
                  type="text"
                  id="trilha.title"
                  name="trilha.title"
                  value={formData.trilha.title}
                  onChange={handleChange}
                  placeholder="Título da Trilha a ser cadastrada"
                />
              </FormField>

              <FormField>
                <Label htmlFor="trilha.description">Descrição da Trilha</Label>
                <TextArea
                  id="trilha.description"
                  name="trilha.description"
                  value={formData.trilha.description}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Descrição da Trilha a ser cadastrada"
                />
              </FormField>

              <FormField>
                <Label htmlFor="trilha.cursos">Cursos (IDs)</Label>
                <Input
                  type="text"
                  id="trilha.cursos"
                  name="trilha.cursos"
                  value={formData.trilha.cursos}
                  onChange={handleChange}
                  placeholder="Digite os id's do curso separados por vírgula"
                />
                <a href="/admin/cursos/conteudo" target="_blank">
                  consultar ids dos cursos
                </a>
              </FormField>

              <Button type="submit">Criar</Button>
            </form>
          </>
        )}
      </StyledModal>
      {showModal && (
        <CreateLMSModal
          lmsID={selectedLmsID}
          onClose={handleCloseModal}
          onSubmit={() => {
            location.reload();
            handleCloseModal();
          }}
        />
      )}
    </>
  );
};
